import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import makeComponentTrashable from 'trashable-react';
import { fetchInvoiceEvents } from 'Shared/util/web-api';
import { formatAmount } from 'Shared/util/formatters';
import DataTable, { ColumnTypes } from 'Shared/components/tables/data-table';
import Spinner from 'Shared/components/spinner';
import { useTranslation } from 'Shared/util/custom-hooks';
import { translateColumns, funcFilterStatus } from 'Shared/util/translations';


const columns = [{
  title: 'invoiceNumber',
  key: 'number',
}, {
  title: 'customer',
  key: 'name',
}, {
  title: 'totalAmount',
  key: 'totalAmount',
  type: ColumnTypes.Amount,
  formatter: (d) => formatAmount(d),
}, {
  title: 'currency',
  key: 'currencyCode',
}, {
  title: 'status',
  key: 'status',
}];

const getRowLink = (row) => `/invoices/${row.id}`;


const EventSection = ({
  registerPromise,
}) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const tg = useTranslation(x => x.global);
  const t = useTranslation(x => x.eventSection);

  useEffect(() => {
    registerPromise(fetchInvoiceEvents())
      .then((result) => {
        setEvents(result);
        setLoading(false);
      });
  }, []);

  return (
    <>
      {loading ? <Spinner /> : (
        <div>
          <h3>
            {t.lastWeeksDeviatingInvoiceEvents}
          </h3>
          <DataTable
            columns={translateColumns(columns, tg)}
            rows={funcFilterStatus(events, t, 'status')}
            getRowLink={getRowLink}
            pageSize={10}
          />
        </div>
      )}
    </>
  );
};

EventSection.propTypes = {
  registerPromise: PropTypes.func.isRequired,
};

export default makeComponentTrashable(EventSection);
